import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../redux/store'

interface UserState {
    role: string
    firstName: string
    email: string
    id: string
    lastName: string
    image?: string | null
    locationId?: string
    leavePolicyId?: string
}
interface UserPayload {
    role: string
    firstName: string
    email: string
    id: string
    lastName: string
    image?: string | null
    locationId?: string
    leavePolicyId?: string
}
export const userSlice = createSlice({
    name: 'user',
    initialState: {
        role: '',
        firstName: '',
        email: '',
        id: '',
        lastName: '',
        locationId: '',
        leavePolicyId: '',
    } as UserState,
    reducers: {
        User: (state: UserState, action: PayloadAction<UserPayload>) => {
            state.role = action.payload.role as string
            state.firstName = action.payload.firstName as string
            state.email = action.payload.email as string
            state.id = action.payload.id as string
            state.lastName = action.payload.lastName as string
            state.image = action.payload.image
            state.locationId = action.payload.locationId
            state.leavePolicyId = action.payload.leavePolicyId
        },
    },
})

export const { User } = userSlice.actions

export const selectUser = (state: RootState): UserState =>
    state.persistedReducers.user

export default userSlice.reducer
